module.exports = __webpack_public_path__ + "img/livingverify_footer.0b00da60.png";